import React from "react";
import { weatherFaqs, weatherGuidePages, weatherLocationPages } from "@/components/public/weatherSeoGrowthData";

const SITE_URL = "https://marstick.com";

export default function WeatherSeoStructuredData({ prefix = "/en" }) {
  const breadcrumb = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: `${SITE_URL}${prefix}` },
      { "@type": "ListItem", position: 2, name: "Marine Weather", item: `${SITE_URL}${prefix}/weather` },
    ],
  };
  const faq = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: weatherFaqs.map(([question, answer]) => ({
      "@type": "Question",
      name: question,
      acceptedAnswer: { "@type": "Answer", text: answer },
    })),
  };
  const itemList = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Marine weather guides and location forecasts",
    itemListElement: [...weatherLocationPages, ...weatherGuidePages].map(([name, href], index) => ({
      "@type": "ListItem",
      position: index + 1,
      name,
      url: `${SITE_URL}${prefix}${href}`,
    })),
  };
  return [breadcrumb, faq, itemList].map((schema, index) => (
    <script key={index} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
  ));
}